import { render } from "./ForumDetails.vue?vue&type=template&id=3ad0899e&ts=true"
import script from "./ForumDetails.vue?vue&type=script&lang=ts"
export * from "./ForumDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QAvatar,QBtn,QSeparator,QCard,QCardSection});
